export type QuizzOptionKey = 'A' | 'B' | 'C' | 'D';

export interface QuizzQuestionI {
   id: number;
   question: string;
   options: { key: QuizzOptionKey; text: string }[];
}

export const QUIZZ_TITLE = 'Quiz de Cultura y Excelencia';

export const quizzQuestions: QuizzQuestionI[] = [
   {
      id: 1,
      question: 'Un cliente te solicita un maquillaje que sabes que no funcionará bien con su tipo de piel. ¿Cómo actúas?',
      options: [
         { key: 'A', text: 'Lo realizas exactamente como lo pide.' },
         { key: 'B', text: 'Explicas profesionalmente las limitaciones y propones alternativas.' },
         { key: 'C', text: 'Lo realizas y aclaras al final que el resultado puede variar.' },
         { key: 'D', text: 'Le dices que no puedes atenderlo.' },
      ],
   },
   {
      id: 2,
      question: 'Tu cita comienza a las 10:00 AM y a las 9:40 AM sabes que llegarás a las 10:05 AM. ¿Qué debes hacer?',
      options: [
         { key: 'A', text: 'Avisar al cliente cuando estés cerca.' },
         { key: 'B', text: 'Avisar inmediatamente a Call Center y seguir sus indicaciones.' },
         { key: 'C', text: 'Llegar y ofrecer una disculpa.' },
         { key: 'D', text: 'Pedir al cliente que retrase su preparación.' },
      ],
   },
   {
      id: 3,
      question: 'Una clienta te ofrece contratarte directamente para su próxima boda, sin pasar por Good Look. ¿Qué haces?',
      options: [
         { key: 'A', text: 'Aceptas si es fuera de tu horario habitual.' },
         { key: 'B', text: 'Aceptas si no utilizas productos de Good Look.' },
         { key: 'C', text: 'Le indicas que las reservaciones deben gestionarse por Good Look.' },
         { key: 'D', text: 'Le das tu contacto y esperas que ella decida.' },
      ],
   },
   {
      id: 4,
      question: 'Durante un servicio, la clienta comenta que es alérgica a un ingrediente de algunos cosméticos. ¿Cuál es la mejor decisión?',
      options: [
         { key: 'A', text: 'Utilizar productos de marcas premium porque son más seguros.' },
         { key: 'B', text: 'Evitar los productos que puedan contener el ingrediente, revisar la información y consultar ante dudas.' },
         { key: 'C', text: 'Aplicar una cantidad pequeña para comprobar si reacciona.' },
         { key: 'D', text: 'Preguntar si anteriormente ha utilizado maquillaje y continuar.' },
      ],
   },
   {
      id: 5,
      question: 'Llegas a un servicio y la clienta solicita un peinado adicional que no estaba reservado. ¿Qué haces?',
      options: [
         { key: 'A', text: 'Lo realizas y acuerdas un precio con ella.' },
         { key: 'B', text: 'Lo realizas gratis si tienes tiempo.' },
         { key: 'C', text: 'Consultas con Call Center disponibilidad, autorización y condiciones.' },
         { key: 'D', text: 'Le dices que no se puede sin consultar.' },
      ],
   },
   {
      id: 6,
      question: '¿Qué representa realmente la calidad dentro de Good Look?',
      options: [
         { key: 'A', text: 'Utilizar únicamente productos costosos.' },
         { key: 'B', text: 'Lograr un resultado visualmente atractivo.' },
         { key: 'C', text: 'Combinar técnica, higiene, puntualidad, productos adecuados y experiencia del cliente.' },
         { key: 'D', text: 'Terminar los servicios en el menor tiempo posible.' },
      ],
   },
   {
      id: 7,
      question: 'Una clienta está inconforme con el maquillaje y comienza a hablarte de manera molesta. ¿Cómo procedes?',
      options: [
         { key: 'A', text: 'Defiendes tu trabajo porque seguiste la referencia.' },
         { key: 'B', text: 'Escuchas, identificas el problema, propones un ajuste razonable y contactas a operación si es necesario.' },
         { key: 'C', text: 'Le ofreces un reembolso inmediato.' },
         { key: 'D', text: 'Le indicas que debe comunicarse con Good Look después.' },
      ],
   },
   {
      id: 8,
      question: 'Un cliente famoso acepta que le tomes una fotografía para el reporte interno, pero no autoriza publicarla. ¿Qué haces?',
      options: [
         { key: 'A', text: 'La compartes en tus historias etiquetando a Good Look.' },
         { key: 'B', text: 'La publicas sin mencionar su nombre.' },
         { key: 'C', text: 'Respetas la autorización y no la publicas.' },
         { key: 'D', text: 'La compartes únicamente con tus seguidores cercanos.' },
      ],
   },
   {
      id: 9,
      question: 'Durante un servicio Premium descubres que olvidaste uno de tus productos principales. ¿Cuál es el procedimiento?',
      options: [
         { key: 'A', text: 'Utilizar cualquier sustituto disponible.' },
         { key: 'B', text: 'Pedirle a la clienta que te preste uno.' },
         { key: 'C', text: 'Informar a operación y buscar una alternativa adecuada y autorizada.' },
         { key: 'D', text: 'Continuar sin mencionar el faltante.' },
      ],
   },
   {
      id: 10,
      question: '¿Cuál de las siguientes situaciones refleja mejor el valor de transparencia?',
      options: [
         { key: 'A', text: 'Prometer que el resultado quedará idéntico a una fotografía.' },
         { key: 'B', text: 'Informar con claridad las posibilidades reales del servicio y comunicar cualquier incidencia.' },
         { key: 'C', text: 'Resolver todos los problemas sin informar a la empresa.' },
         { key: 'D', text: 'Evitar hablar de limitaciones para no preocupar al cliente.' },
      ],
   },
   {
      id: 11,
      question: 'Una clienta te pide extender el servicio 30 minutos, pero tienes otra cita después. ¿Qué haces?',
      options: [
         { key: 'A', text: 'Aceptas porque el cliente siempre tiene la razón.' },
         { key: 'B', text: 'Te retiras inmediatamente sin explicación.' },
         { key: 'C', text: 'Evalúas lo posible dentro del servicio y comunicas a operación cualquier impacto en tu agenda.' },
         { key: 'D', text: 'Le pides a la siguiente clienta que espere.' },
      ],
   },
   {
      id: 12,
      question: '¿Qué debes hacer al llegar al domicilio del cliente?',
      options: [
         { key: 'A', text: 'Comenzar a instalarte sin presentarte.' },
         { key: 'B', text: 'Presentarte como artista Good Look, mostrar tu credencial digital y confirmar el servicio.' },
         { key: 'C', text: 'Pedir al cliente que revise tu portafolio antes de comenzar.' },
         { key: 'D', text: 'Mostrar únicamente tu identificación personal.' },
      ],
   },
   {
      id: 13,
      question: 'Un cliente te pide un descuento especial porque contratará varios servicios. ¿Cómo respondes?',
      options: [
         { key: 'A', text: 'Le ofreces un descuento pequeño por tu cuenta.' },
         { key: 'B', text: 'Consultas con Good Look antes de confirmar cualquier beneficio.' },
         { key: 'C', text: 'Aceptas si paga en efectivo.' },
         { key: 'D', text: 'Le dices que puede pagarte directamente la diferencia.' },
      ],
   },
   {
      id: 14,
      question: 'Durante un servicio escuchas información personal y confidencial de una clienta. ¿Qué corresponde hacer?',
      options: [
         { key: 'A', text: 'Compartirla únicamente con colegas de confianza.' },
         { key: 'B', text: 'Utilizarla como anécdota sin mencionar nombres.' },
         { key: 'C', text: 'Mantener absoluta discreción y respetar la privacidad del cliente.' },
         { key: 'D', text: 'Comentarla si la clienta es una figura pública.' },
      ],
   },
   {
      id: 15,
      question: '¿Qué significa representar a Good Look durante un servicio?',
      options: [
         { key: 'A', text: 'Realizar correctamente el maquillaje o peinado.' },
         { key: 'B', text: 'Promocionar constantemente tus redes sociales.' },
         { key: 'C', text: 'Ser responsable de la experiencia completa: presentación, actitud, puntualidad, técnica y profesionalismo.' },
         { key: 'D', text: 'Utilizar siempre los productos de mayor precio.' },
      ],
   },
   {
      id: 16,
      question: 'Tienes una emergencia personal y no podrás atender una cita que ya aceptaste. ¿Qué haces?',
      options: [
         { key: 'A', text: 'Buscas por tu cuenta a otro maquillista para reemplazarte.' },
         { key: 'B', text: 'Informas inmediatamente a Call Center para que gestione la situación.' },
         { key: 'C', text: 'Le escribes al cliente para cancelar.' },
         { key: 'D', text: 'Esperas hasta estar seguro de que no podrás llegar.' },
      ],
   },
   {
      id: 17,
      question: 'Una clienta solicita un cambio de look que podría comprometer el resultado acordado inicialmente. ¿Qué haces?',
      options: [
         { key: 'A', text: 'Aceptas cualquier cambio sin explicaciones.' },
         { key: 'B', text: 'Le explicas las implicaciones, confirmas expectativas y consultas a operación si modifica el servicio contratado.' },
         { key: 'C', text: 'Te niegas a realizar cualquier ajuste.' },
         { key: 'D', text: 'Realizas el cambio y notificas después.' },
      ],
   },
   {
      id: 18,
      question: '¿Cuál de las siguientes acciones incumple los lineamientos de Good Look?',
      options: [
         { key: 'A', text: 'Compartir contenido autorizado etiquetando a Good Look.' },
         { key: 'B', text: 'Solicitar apoyo a Call Center ante una incidencia.' },
         { key: 'C', text: 'Utilizar información de clientes obtenida mediante Good Look para ofrecer servicios independientes.' },
         { key: 'D', text: 'Participar en capacitaciones de la empresa.' },
      ],
   },
   {
      id: 19,
      question: '¿Qué debes hacer al finalizar correctamente un servicio?',
      options: [
         { key: 'A', text: 'Tomar tus cosas y retirarte para no incomodar.' },
         { key: 'B', text: 'Mostrar el resultado, confirmar satisfacción, dejar limpio el espacio y reportar cualquier incidencia.' },
         { key: 'C', text: 'Pedir obligatoriamente una reseña positiva.' },
         { key: 'D', text: 'Publicar inmediatamente una fotografía del resultado.' },
      ],
   },
   {
      id: 20,
      question: '¿Cuál es el principal objetivo de la Cultura Good Look?',
      options: [
         { key: 'A', text: 'Que todos los artistas utilicen exactamente las mismas técnicas.' },
         { key: 'B', text: 'Que cada artista trabaje de manera independiente sin consultar a la empresa.' },
         { key: 'C', text: 'Garantizar una experiencia consistente, profesional y de excelencia que represente nuestros valores en cada servicio.' },
         { key: 'D', text: 'Incrementar la cantidad de servicios realizados diariamente.' },
      ],
   },
];

const answerKey: Record<number, QuizzOptionKey> = {
   1: 'B', 2: 'B', 3: 'C', 4: 'B', 5: 'C', 6: 'C', 7: 'B', 8: 'C', 9: 'C', 10: 'B',
   11: 'C', 12: 'B', 13: 'B', 14: 'C', 15: 'C', 16: 'B', 17: 'B', 18: 'C', 19: 'B', 20: 'C',
};

export const getQuizzScore = (answers: Record<number, QuizzOptionKey>) => {
   const correctCount = quizzQuestions.filter(({ id }) => answers[id] === answerKey[id]).length;

   let grade = 'Repetir capacitación';
   if (correctCount >= 18) grade = 'Excelente';
   else if (correctCount >= 16) grade = 'Aprobado';
   else if (correctCount >= 14) grade = 'Reforzar conocimientos';

   return { correctCount, totalQuestions: quizzQuestions.length, grade };
};
